import React from 'react';
import { TimePicker } from 'antd';

const InclusionDetailCard = ({
    title,
    pickupPoint,
    dropPoint,
    duration,
    itineraryDetails,
    timePickerId = 'Duration'
}) => {
    return (
        <div className="col-lg-12 col-sm-12 mt-3 mb-2 py-2 form_border ms-2">
            <div className="row">
                {title && (
                    <div className="col-lg-12 col-md-12 mb-1">
                        <label className="col-form-label">{title}</label>
                    </div>
                )}
                <div className="col-lg-12 col-sm-12">
                    <div className="row">
                        <div className="col-lg-1 col-md-2 mb-1">
                            <label className="col-form-label">Pick Up Point</label>
                        </div>
                        <div className="col-lg-3 mb-1 col-md-3">
                            <input
                                type="text"
                                className="form-control"
                                disabled
                                value={pickupPoint || ''}
                                placeholder="PickUpPoint"
                                readOnly
                            />
                        </div>
                        <div className="col-lg-1 col-md-2 mb-1">
                            <label className="col-form-label">Drop Point</label>
                        </div>
                        <div className="col-lg-3 mb-1 col-md-3">
                            <input
                                type="text"
                                className="form-control"
                                disabled
                                value={dropPoint || ''}
                                placeholder="DropPoint"
                                readOnly
                            />
                        </div>
                        <div className="col-lg-1 col-md-3 mb-1">
                            <label className="col-form-label">Duration</label>
                        </div>
                        <div className="col-lg-3 mb-1 col-md-6">
                            <TimePicker
                                id={timePickerId}
                                className="form-control defo_border"
                                disabled
                                placeholder="--"
                                format="HH"
                                value={duration}
                                needConfirm={false}
                                showNow={false}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-lg-12 col-sm-12">
                    <div className="row">
                        <div className="col-lg-2 col-md-12 mb-1">
                            <label className="col-form-label">Itinerary Details</label>
                        </div>
                        <div className="col-lg-10 mb-1 col-md-12">
                            <textarea
                                className="form-control"
                                value={itineraryDetails || ''}
                                disabled
                                readOnly
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(InclusionDetailCard);

